<template>
  <div :class="_.loading">
    <van-loading type="circular" />
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module>
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 0;
  }
</style>
